import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { fetchContracts, fetchProjectTitles } from '../../actions/project_actions';
import { titleOptionsForDivision } from '../../utils/team';
import { formatPhoneInput } from '../../utils';

class MemberForm extends React.Component {
  constructor (props) {
    super(props);
    const { projectTitleId, externalConsultant } = props.teamObj;

    this.consultantFields = [
      'id', 'firstName', 'lastName', 'email', 'tel', 'contractId',
    ];

    this.state = {
      projectTitleId,
      ..._.pick(externalConsultant, this.consultantFields),
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTelChange = this.handleTelChange.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleContractChange = this.handleContractChange.bind(this);
  }

  UNSAFE_componentWillMount () {
    const { projectId, contracts, projectTitles } = this.props;
    if (projectTitles.length === 0) this.props.fetchProjectTitles();
    if (contracts.length === 0) this.props.fetchContracts(projectId);
  }

  getTitleOptions () {
    const { projectTitles, divisionName, groupName } = this.props;
    return titleOptionsForDivision(projectTitles, divisionName, groupName)
  }

  getContractOptions () {
    return this.props.contracts.map(contract => {
      return {
        label: `${contract.regNumber} - ${contract.contractor}`,
        value: contract.id
      }
    });
  }

  handleContractChange (option) {
    const contractId = option ? option.value : '';
    this.setState({ contractId });
  }


  handleTitleChange (option) {
    const projectTitleId = option ? option.value : '';
    this.setState({ projectTitleId });
  }

  handleTelChange (e) {
    let tel = e.target.value;
    tel = tel.replace(/\D/g, '').substring(0, 10);
    this.setState({ tel });
  }

  handleChange (field) {
    return (e) => {
      this.setState({ [field]: e.target.value });
    }
  }

  handleSubmit (e) {
    e.preventDefault();
    if (!this.isValid()) return;

    const { projectTitleId } = this.state;
    const externalConsultant = _.pick(this.state, this.consultantFields);

    this.props.onSave({
      ...this.props.teamObj,
      projectTitleId,
      externalConsultant,
    });
  }

  isValid () {
    const fields = ['firstName', 'lastName', 'projectTitleId'];
    return _.every(_.pick(this.state, fields))
  }

  render () {
    return (
      <form onSubmit={this.handleSubmit}>

        <div className="member-details two-cols">
          <div className="control required">
            <label>First Name</label>
            <input type="text" name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange('firstName')}
            />
          </div>
          <div className="control required">
            <label>Last Name</label>
            <input type="text" name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange('lastName')}
            />
          </div>
        </div>

        <div className="member-details two-cols">
          <div className="control">
            <label>Email</label>
            <input type="email" name="email"
              value={this.state.email}
              onChange={this.handleChange('email')}
            />
          </div>
          <div className="control">
            <label>Phone</label>
            <input type="tel" name="tel"
              value={formatPhoneInput(this.state.tel)}
              onChange={this.handleTelChange}
            />
          </div>
        </div>

        { this.props.contracts.length
          ? <div className="control">
              <label>Contract</label>
              <Select name=""
                value={this.state.contractId}
                options={this.getContractOptions()}
                onChange={this.handleContractChange}
              />
            </div>
          : null }

        <div className="control required">
          <label>Title</label>
          <Select name="documentType"
            value={this.state.projectTitleId}
            options={this.getTitleOptions()}
            onChange={this.handleTitleChange}
          />
        </div>

        <button className="btn-update" disabled={!this.isValid()}>
          { this.props.teamObj.id ? 'Save' : 'Add consultant' }
        </button>
      </form>
    )
  }
}

MemberForm.propTypes = {
  projectId: PropTypes.string.isRequired,
  teamObj: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  divisionName: PropTypes.string.isRequired,
  groupName: PropTypes.number.isRequired,
  contracts: PropTypes.array.isRequired,
  projectTitles: PropTypes.array.isRequired,
  fetchContracts: PropTypes.func.isRequired,
  fetchProjectTitles: PropTypes.func.isRequired
};

function mapStateToProps (state) {
  return {
    contracts: state.projectsStore.contracts,
    projectTitles: state.projectsStore.projectTitles,
    divisionName: state.projectsStore.divisionName,
    groupName: state.projectsStore.groupName
  };
}

export default connect(mapStateToProps, {
  fetchContracts,
  fetchProjectTitles,
})(MemberForm);